import React from "react";

export type TArrawDownIconProps = React.SVGAttributes<SVGElement>;

export function ArrawDownIcon({ ...rest }: TArrawDownIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99996 9.53608L2.28576 4L1 5.24568L7.97164 12L7.99996 11.9726L8.02828 12L14.9999 
          5.24568L13.7142 4L7.99996 9.53608Z"
        fill="#7F94A1"
      />
    </svg>
  );
}
